import React from 'react';

export default function PageLoader() {
  return (
    <div className="flex w-full min-h-[calc(100dvh-7rem)] items-center justify-center lg:min-h-[calc(100dvh-4rem)]">
      <div
        className="h-12 w-12 shrink-0 animate-spin rounded-full border-2 border-blue-500/30 border-t-blue-500"
        aria-hidden
      />
    </div>
  );
}
